/**
 * apps/wildswim-web/src/main.tsx
 *
 * React application entry point. Mirrors the flagship apps/web
 * pattern: Helmet + QueryClient + Auth providers wrapping App.
 */

import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import faviconSvg from './brand/hattie-mark.svg';

// Set the favicon from the Vite-hashed asset URL so a brand SVG
// edit auto-busts every browser's favicon cache (including Safari's).
{
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = faviconSvg;
    document.head.appendChild(link);
}
import { queryClient } from './lib/queryClient';
import { AuthProvider } from './providers/AuthProvider';
import { HomeSpotProvider } from './providers/HomeSpotProvider';
import { CheckinProvider } from './providers/CheckinProvider';
import { PrefsProvider } from './providers/PrefsProvider';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <PrefsProvider>
                        <HomeSpotProvider>
                            <CheckinProvider>
                                <App />
                            </CheckinProvider>
                        </HomeSpotProvider>
                    </PrefsProvider>
                </AuthProvider>
            </QueryClientProvider>
        </HelmetProvider>
    </React.StrictMode>,
);
